import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {

} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Update the context map, like for deleting or reprioritizing nodes
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestUpdateInquiryContext = packet => {
  return {
    type: 'REQUEST_UPDATE_INQUIRY_CONTEXT',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveUpdateInquiryContextSuccess = data => ({
  type: 'RECEIVE_UPDATE_INQUIRY_CONTEXT_SUCCESS',
  data
})

export const receiveUpdateInquiryContextFail = data => ({
  type: 'RECEIVE_UPDATE_INQUIRY_CONTEXT_FAIL',
  data
})

export const tryToUpdateInquiryContext = packet => (dispatch, getState) => {

  dispatch(requestUpdateInquiryContext(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;
  return fetch('/api/inquiries/context-map/' + packet.inquiry_id, {
      method: 'put',
      body: JSON.stringify(packet),
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveUpdateInquiryContextSuccess(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveUpdateInquiryContextFail({errors:e, lastSubmit: packet}));
    })
}
